import Vue from 'vue';
import VueRouter from 'vue-router';
import Cookies from 'js-cookie';

Vue.use(VueRouter);

import userRouter from './modules/user';
import mallRouter from './modules/mall';
import afterSaleRouter from './modules/after-sale';
import boActivityRouter from './modules/bo-activity';
import puhuiRouter from './modules/puhui';
import otherRouter from './modules/other';
import goldCoinRouter from './modules/gold-coin';

const routes = [
  ...userRouter,
  ...mallRouter,
  ...afterSaleRouter,
  ...boActivityRouter,
  ...puhuiRouter,
  ...otherRouter,
  ...goldCoinRouter,
  {
    path: '/',
    redirect: '/login',
  },
];

const router = new VueRouter({
  routes,
});

const showTabBarPages = ['/puhui'];

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title : '普惠平台';
  const isLogged = Cookies.get('token') || null;
  // if (!isLogged && to.meta.auth) {
  //   next({
  //     path: '/login',
  //     query: { redirect: from.fullPath }, // redirect参数为web页面跳转登录后需要返回的路由
  //   });
  // } else {
    // 隐藏或者显示app底部TabBar
    if (Vue.prototype.$getIsApp()) {
      const method = showTabBarPages.includes(to.path)
        ? 'ShowTabBarMethod'
        : 'HiddenTabBarMethod';

      Vue.prototype.$callApp('Android', method, '');
      Vue.prototype.$callApp('iOS', method, '');
    }

    next();
  // }
});

export default router;
